import styled from 'styled-components'

export interface IBackgroundShadowProps {
    isOpen: boolean
}

export const BackgroundShadow = styled.div<IBackgroundShadowProps>`
    background-color: ${({ isOpen }) => (isOpen ? 'rgba(0, 0, 0, 0.5)' : 'transparent')};
    display: ${({ isOpen }) => (isOpen ? 'inline' : 'none')};
    left: 0;
    bottom: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 1300;
`